import { useEffect } from "react";
import Slider from "../../components/Slider/Slider";
import "./Verband.css";

function Verband() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <Slider></Slider>
      <div className="verbandAllgemeinDiv">
        <br></br>
        <p>
          Der Verband der HörspielRegie (VdHR e.V.) vertritt die Interessen der
          Regisseurinnen und Regisseure im Bereich Hörspiel und Radiokunst. Er
          wurde 2007 gegründet, um die Zukunft des Hörspiels im
          deutschsprachigen Raum aktiv mit zu gestalten. Die zentralen Ziele des
          VdHR: Pflege und Ausbau der Hörspielkultur, hohe Qualitätsstandards,
          die Erhaltung fairer Arbeits- und Honorarbedingungen. Im VdHR bündeln
          sich vielfältige und langjährige Erfahrungen in der
          Hörspielproduktion, die wir gerne teilen. Bei Fragen zu Honoraren,
          Tarif- oder Vertragsgestaltung, versuchen wir konkrete Ansprechpartner
          zu vermitteln. Unsere Arbeits- und Interessenspartner sind die
          öffentlich-rechtlichen Rundfunkanstalten, Print- und Audio-Verlage,
          die Gewerkschaften und die Verwertungsgesellschaften, sowie andere
          Berufsverbände im Bereich Medien. Der Verband der HörspielRegie ist
          über den
          <a href="http://deutschermedienrat.de/"> Deutschen Medienrat </a>
          Mitglied im
          <a href="https://www.kulturrat.de/"> Deutschen Kulturrat </a>
          und Unterstützer der
          <a href="https://urheber.info/"> Initiative Urheberrecht</a>.
        </p>
      </div>
    </>
  );
}

export default Verband;
